
import * as HTTP from '@/utils/http'
export default {
    /*查询批注列表（新）*/
    getPageList(param){
        "use strict";
        return HTTP.POST('/annotation/problem/annotation/manage/page/list', param)
    },
    /*批量删除（新）*/
    deleteBatch(param){
        "use strict";
        return HTTP.POST('/annotation/problem/delete/batch', param)
    },
    /*批量删除（新）*/
    exportExcel(param){
        "use strict";
        return HTTP.POST('/annotation/problem/export/excel', param)
    },
    exportTest(param){
        "use strict";
        return HTTP.GET('/annotation/problem/export/excel/test?problemId=1861250578666110976')
    },
}